export const BackgroundColor = '#232323';
export const White = '#FFFFFF';
export const LightBlue = '#0DD7F7';
export const DarkBlue = '#0C3D71';
export const BlackShade = '#1E1E1E';
export const GreyShade = '#2E2E2E';
export const BorderColor = '#27353A';
